export enum EntryStatus {
  NUEVO = 'Nuevo',
  TRAMITE_INGRESO = 'Trámite de ingreso',
  DEVUELTO = "Devuelto",
  ENVIADO = 'Enviado',
  FINALIZADO = 'Finalizado',
}

export enum EntryStatusIds {
  NUEVO_ID = 3,
  TRAMITE_INGRESO_ID = 4,
  DEVUELTO_ID = 5,
  FINALIZADO_ID = 7,
}
